<template>
    <div class="modal-content">
        <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
        </div>
        <div class="modal-body">
            <vue-simple-spinner class="m-t-20" v-if="loading"></vue-simple-spinner>
            <div v-if="!loading">
                <div v-if="step == 0">
                    <h2 class="text-center m-b-30">Faça uma <b>Reserva Segura</b> deste anúncio!</h2>

                    <p class="m-b-15 text-dark h5"><b>Faça o pagamento do primeiro mês de aluguel pelo WebQuarto, de forma totalmente segura.</b></p>

                    <div class="booking_property card-box m-b-15 text-left">
                        <img class="prop_photo" :src="property_ad.main_photo" alt="" />
                        <div class="b_details">
                            <p class="prop_title">{{ property_ad.title }}</p>
                            <p class="prop_location text-muted">{{ property_ad.location }}</p>
                            <p class="prop_price text-success">{{ property_ad.rent_price_view }}</p>
                        </div>
                    </div>

                    <ul class="list-unstyled text-left">
                        <li class="m-b-15"><i class="far fa-check-circle text-success m-r-5"></i> {{ contact.first_name }} deve aceitar sua solicitação em até 72 horas.</li>
                        <li class="m-b-15"><i class="far fa-check-circle text-success m-r-5"></i> Após ter sua solicitação aceita, você poderá realizar o pagamento do primeiro mês de aluguel.</li>
                        <li class="m-b-15"><i class="far fa-check-circle text-success m-r-5"></i> {{ contact.first_name }} apenas receberá o valor do aluguel 24 horas após a mudança ser confirmada, caso
                        você não informe nenhum problema durante este período.</li>
                    </ul>

                    <div class="m-t-30 row">
                        <div class="col-xs-12 col-sm-6">
                            <a class="btn btn-block btn-white btn-lg w-lg waves-effect waves-light" target="_blank" href="/reserva-segura">Como funciona?</a>
                        </div>
                        <div class="col-xs-12 col-sm-6">
                            <button @click="showForm()" class="btn btn-success btn-block btn-lg w-lg waves-effect waves-light btn_initbooking ladda-button">
                                <span class="ladda-label">Continuar</span>
                            </button>
                        </div>
                    </div>
                </div>

                <div v-if="step == 1">
                    <h3 class="m-b-30 text-center">Preencha os detalhes da reserva</h3>
                    <p class="m-b-30 h5">Preencha o campo abaixo com a data que você pretende se mudar. Você ainda poderá negociar todos os detalhes com seu anfitrião.</p>
                    <div class="row">
                        <div class=" col-xs-12 col-sm-6">
                            <div class="form-group" v-bind:class="{'has-error': errors.has('moving_date')}">
                                <label for="email" class="control-label">Data de mudança</label>
                                <date-picker
                                    v-model="form.moving_date"
                                    :disabled-date="disabledDate"
                                    :open.sync="open_picker"
                                    value-type="format"
                                    format="DD/MM/YYYY">
                                        <template v-slot:input>
                                            <input type="tel"
                                                class="form-control"
                                                data-vv-as="Data de Mudança"
                                                autocomplete="off"
                                                v-validate="'required|date_format:dd/MM/yyyy'"
                                                v-mask="'##/##/####'"
                                                placeholder="dd/mm/aaaa"
                                                @input="dateChange"
                                                v-model="form.moving_date" name="moving_date"/>
                                        </template>
                                </date-picker>
                                <span class="help-block text-left" v-show="errors.has('moving_date')">
                                    <strong>{{ errors.first('moving_date') }}</strong>
                                </span>
                            </div>
                        </div>

                        <div class="col-xs-12 col-sm-6">
                            <div class="form-group" v-bind:class="{'has-error': errors.has('staying_time')}">
                                <label for="staying_time" class="control-label">Tempo de Permanência</label>
                                <select class="form-control" v-model="form.staying_time" data-vv-as="Tempo de Permanência" v-validate="'required'" name="staying_time">
                                    <option value="">Selecione</option>
                                    <option>Menos de 1 mês</option>
                                    <option>Até 3 meses</option>
                                    <option>Até 6 meses</option>
                                    <option>Mais de 6 meses</option>
                                    <option>Indeterminado</option>
                                </select>
                                <span class="help-block text-left" v-show="errors.has('staying_time')">
                                    <strong>{{ errors.first('staying_time') }}</strong>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="card-box">
                        <p><b>Sua Reserva:</b></p>

                        <p>Primeiro Aluguel: <span class="pull-right"><b>{{ booking.rent_price }}</b></span></p>
                        <p>Taxa de Serviço: <span class="pull-right"><b>{{ booking.service_fee }}</b></span></p>
                        <p>Valor da Reserva: <span class="pull-right"><b>{{ booking.total }}</b></span></p>
                    </div>
                    <p class="m-b-20"><i class="fas fa-exclamation-triangle"></i> Você não precisará pagar nenhum valor agora!</p>

                    <div class="row text-right m-t-15">
                        <div class="col-xs-12 col-sm-6">
                            <button class="btn btn-block btn-white btn-lg w-lg waves-effect waves-light" @click="back()">Voltar</button>
                        </div>
                        <div class="col-xs-12 col-sm-6">
                            <button class="btn btn-success btn-lg btn-block waves-effect waves-light ladda-button" @click="showMessageForm()">
                                <span class="ladda-label">Continuar</span>
                            </button>
                        </div>
                    </div>
                </div>

                <div v-if="step == 2">
                    <h3 class="m-b-30 text-center">Envie uma mensagem para {{ contact.first_name }}</h3>
                    <p class="m-b-30 h5">Use o campo abaixo para se apresentar, dar mais informações sobre o motivo de sua mudança, e perguntar quaisquer questões sobre o anúncio.</p>
                    <div class="dv_msg_success text-left">
                        <div class="form-group" v-bind:class="{'has-error': errors.has('message')}">
                            <label for="message" class="control-label">Mensagem</label>
                            <textarea name="message" v-validate="'required'" class="form-control" v-model="form.message" :placeholder="'Digite aqui sua mensagem para ' + contact.first_name + '.'" rows="6"></textarea>
                            <span class="help-block text-left" v-show="errors.has('message')">
                                <strong>{{ errors.first('message') }}</strong>
                            </span>
                        </div>
                    </div>
                    <div class="row text-right m-t-15">
                        <div class="col-xs-12 col-sm-6">
                            <button class="btn btn-block btn-white btn-lg w-lg waves-effect waves-light" @click="back()">Voltar</button>
                        </div>
                        <div class="col-xs-12 col-sm-6">
                            <button class="btn btn-success btn-lg btn-block waves-effect waves-light ladda-button btn_request_booking" @click="submit()">
                                <span class="ladda-label">Enviar</span>
                            </button>
                        </div>
                    </div>
                </div>

                <div v-if="step == 3">
                    <h3 class="m-b-30 text-center">Pedido de Reserva enviado com sucesso!</h3>

                    <p class="m-t-30">Seu pedido de reserva segura foi enviado para {{ contact.first_name }}. Assim que ele(a) responder ao seu pedido,
                        você poderá prosseguir com o aluguel. Clique no botão abaixo para ver sua conversa com {{ contact.first_name }}.
                    </p>

                    <div class="row text-center m-t-30">
                        <div class="col-xs-12">
                            <a class="btn btn-success btn-lg w-lg waves-effect waves-light" href="/mensagens/">
                                Ver Conversa
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from '../../../../../../legacy/node_modules/vue2-datepicker';
import '../../../../../../legacy/node_modules/vue2-datepicker/index.css';
export default {
    props: ['fk_property_ad'],
    components: {DatePicker},
    data: function () {
        return {
            open_picker: false,
            step: 0,
            property_ad: {},
            loading: true,
            form: {
                moving_date: '',
                staying_time: '',
                message: '',
            },
            booking: {},
            contact: {}
        }
    },
    methods: {
        back() {
            this.step--;
        },
        disabledDate(date) {
            var d = new Date().setHours(0,0,0,0);
            return date < d;
        },
        dateChange() {
            this.open_picker = false;
        },
        showForm: function () {
            this.step = 1;
        },
        getData: function () {
            let _this = this;
            axios.get('/booking/preview-data/' + this.fk_property_ad).then(function (res) {
                let data = res.data;
                _this.loading = false;
                _this.property_ad = data.data.property_ad;
                _this.booking = data.data.booking;
                _this.contact = data.data.user;
            });
        },
        showMessageForm: function () {
            this.$validator.validateAll().then((res) => {
                if (!res)
                    return false;

                this.step++;
            });
        },
        submit: function () {
            this.$validator.validateAll().then((res) => {
                if (!res)
                    return false;

                let l = Ladda.create(document.querySelector('.btn_request_booking'));
                l.start();

                let obj = this.form;
                obj.fk_user_host = this.contact.id;
                obj.fk_property = this.fk_property_ad;

                axios.post('/booking/create-withmsg', obj).then( (res) => {
                    l.stop();

                    var data = res.data;
					if (data.response) {
                        window.App.success('Pedido de reserva enviado. Acesse sua caixa de mensagens para conversar com ' + this.contact.first_name);
                        this.step++;
                    }

                    window.dataLayer.push({
                        'event': 'send_booking_request',
                        'event_category': 'property_ad_page',
                        'event_label': 'send_booking_request',
                    });
                }).catch(err => {
                    l.stop();
                    window.App.error('Ocorreu um erro. Por favor, atualize esta página e tente novamente!');
                    Sentry.captureExcetion(err);
                });
            })
        }
    },
    created: function () {
        this.getData();
        this.$validator.localize('pt_BR', {
            custom: {
                phone: {
                    min: 'Este campo deve conter ao menos 14 caracteres',
                }
            },
            messages: {
                required: 'Este campo é obrigatório!',
                date_format: 'Este campo deve conter uma data válida!'
            }
        });
    }
}
</script>

<style lang="scss">
.mx-datepicker-popup { z-index: 1060; }
.mx-datepicker {
    width: 100% !important;
}
.booking_property {
    width: 100%;
    position: relative;
    margin: 0 auto;
    display: flex;

    img {
        height: 70px;
    }

    .b_details {
        padding-left: 25px;

        p {
            margin-bottom: 5px;
        }

        .prop_title {
            font-weight: bold;
            font-size: 14px;
        }

        .prop_price {
            font-weight: bold;
        }
    }
}
</style>